import { extendTheme } from '@chakra-ui/react'
//import '@fontsource/dm-sans'

const theme = extendTheme({
    fonts: {
      heading: `'DM Sans', sans-serif`,
      body:  `'Roboto', sans-serif`, 
    },
    global: {

    },
  });

  export default theme
